const situations = [
  'высокая ценность специалиста для компании;',
  'дефицит компетенций на рынке;',
  'угроза ухода ключевого сотрудника;',
  'сопротивление изменениям;',
  'завышенные требования сотрудника;',
  'отказ брать дополнительную ответственность;',
  'попытки влиять на руководителя.',
];

export default function StrongEmployees() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Переговоры с сильными сотрудниками
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Ситуации, когда руководитель не может просто приказать — потому что на кону ценность специалиста и отношения
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-star-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Баланс в переговорах с сильным сотрудником — это интересы бизнеса плюс интересы сотрудника плюс границы руководителя. Универсального совета «просто поставьте сотрудника на место» здесь нет.
          </p>
        </div>
      </div>
    </section>
  );
}